<template>
    <div :class="fieldErrors[id] ? 'error' : ''">
        <label class="md:w-2/3 block font-bold flex items-center cursor-pointer"
               :class="[fieldErrors[id] ? 'text-red-500' : 'text-gray-700']">
            <input
                    :id="id"
                    :checked="value"
                    @change="$emit('input', $event.target.checked)"
                    type="checkbox"
                    class="mr-2 leading-tight"/>
            <span class="text-sm">{{label}}</span>
        </label>
        <div v-if="fieldErrors[id]" class="text-red-500 text-xs italic">
            {{fieldErrors[id]}}
        </div>
    </div>
</template>

<script>

    export default {
        props: {
            id: {
                type: String,
                required: true
            },
            value: {
                type: Boolean,
            },
            label: {
                type: String
            },
            fieldErrors: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        }
    }
</script>

<style scoped>
</style>
